const translations: {[lang: string]: {[key: string]: string} } = {
    ru: {
        title: "Ваш ключ",
        hello: "Привет",
        logout: "Выйти",
        local_saves: "Локальные сохранения в браузере",
        please_login: "Пожалуйста войдите или зарегистрируйтесь:",
        greetings: "Здесь вы можете управлять Вашими ключами.",
        plan: "Магазин",
        free: "Бесплатный",
        readonly_win9x: "Эмуляция Win9x только для чтения",
        please_reload_page: "Перезагрузите страницу",
        key: "Ваш ключ (нажмите кнопку обновить если нужно)",
        unable_to_cancel_subscription: "Не удалось отменить подписку",
        subscription_cancelled: "Подписка отменена",
        premium: "Подписка",
        cancel: "Отказаться",
        try_free: "дней бесплатно",
        buy: "Купить",
        cloud_saves: "Облачные сохранения",
        private_rooms: "Приватные комнаты",
        experimental_features: "Доступ к премиум функциям",
        writeable_fat32: "Эмуляция Win9x в режиме записи",
        net_no_limits: "Выбор сервера для стевой игры",
        please_reload_on_success: "Пожалуйста перезгрузите эту страницу после покупки",
        can_i_share_key: "Могу я поделиться секретным ключом?",
        can_i_share_content: `Да, конечно.
            Только имейте ввиду, что секретный ключ предоставляет полный доступ к облачным сохранениям.
            В случае конкурентной записи файловая система может быстро выйти из строя.`,
        help: "Нужна помощь?",
        help_content: "Документация js-dos (подписки)",
        sso_title: "Вход через js-dos",
        sso_greetings: "",
        active: "активна",
        notactive: "неактивна",
        premium_options: "Преимущества подписки",
        thirty_days_pass: "Абонемент на +30 дней",
        single_payment: "Разовый платеж",
        subscription: "Подписка",
        days: "дней",
        six_months_pass: "Абонемент на +6 месяцев",
        loading: "Загрузка...",
    },
    en: {
        title: "Your key",
        hello: "Hello",
        logout: "logout",
        local_saves: "Local saves in browser",
        please_login: "Please login or register:",
        greetings: "Here you can manage your keys.",
        plan: "Store",
        free: "Free",
        please_reload_page: "Please reload the page",
        readonly_win9x: "Win9x emulation in read only mode",
        unable_to_cancel_subscription: "Unable to cancel subscription",
        subscription_cancelled: "Subscription cancelled",
        key: "Your key (click the button to regenerate if needed)",
        premium: "Subscription",
        cancel: "Cancel",
        try_free: "days for free",
        buy: "Buy",
        cloud_saves: "Cloud saves",
        private_rooms: "Private rooms",
        experimental_features: "Access to premium features",
        writeable_fat32: "Win9x emulation with write support",
        net_no_limits: "Change the network region",
        please_reload_on_success: "Please reload this page after purchase",
        can_i_share_key: "Can I share secret key?",
        can_i_share_content: `Yep, you can.
            But take in mind that secret key provides direct access to your cloud saves.
            In the case of concurrent writing, they will quickly become broken.`,
        help: "Need help?",
        help_content: "js-dos documentation (subscription)",
        sso_title: "js-dos login",
        sso_greetings: "",
        active: "active",
        notactive: "not active",
        premium_options: "Premium benefits",
        thirty_days_pass: "+30 days pass",
        single_payment: "Single payment",
        subscription: "Subscription",
        days: "days",
        six_months_pass: "+6 months pass",
        loading: "Loading...",
    },
};

export const lang = navigator.language.startsWith("ru") ? "ru" : "en";

export function useT() {
    return (key: string) => {
        return translations[lang][key] ?? key;
    };
};
